export const watchForEngaged40_40 = (sendEngagedEvent: () => void) => {
  if (typeof window !== `undefined`) {
    // Set up the throttler
    function throttle(fn: () => void, delay: number) {
      // Capture the current time
      let time = Date.now()

      // Here's our logic
      return () => {
        if (time + delay - Date.now() <= 0) {
          // Run the function we've passed to our throttler,
          // and reset the `time` variable (so we can check again).
          fn()
          time = Date.now()
        }
      }
    }

    function getScrollPercent() {
      var h = document.documentElement,
        b = document.body

      const win = window as any
      var scrollPercent =
        ((h.scrollTop || b.scrollTop) /
          ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) *
        100

      if (scrollPercent >= 40) {
        if (!win.engagedSent) {
          win.engagedSent = true
          sendEngagedEvent()
        }
      } else if (!win.scrollListener && !win.engagedSent) {
        win.scrollListener = true
        document.addEventListener("scroll", throttle(getScrollPercent, 2000))
      }
    }

    setTimeout(getScrollPercent, 40000)
  }
}
